'use strict';

const angular = require('angular');

export class alertsComponent {
  /*@ngInject*/
  constructor($mdToast, $timeout, common) {
    'ngInject';
    this.$mdToast = $mdToast;
    this.$timeout = $timeout;
    this.common = common;
  }
}

export default angular.module('directives.alerts', [])
  .component('alerts', {
    template: require('./alerts.html'),
    controller: alertsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/alerts/alerts.component.js